import { store, router } from "@/main";
import {
  calcPriceAndEffect,
  getInfoFromOffer,
  getResourceFromOffer,
  Offer
} from "@/services/offer/offer_handle";
import { FeatureItem, PayWay } from "@/services/payment/types";
import * as cg_user_types from "@/store/constants/cg_user_types";
import * as types from "@/store/constants/index_types";
import * as setting_types from "@/store/constants/setting_types";
import {
  getAppPlatform,
  getBundleId,
  getDeviceId,
  getIDFA,
  getIDFV,
  getLang,
  getMachine,
  getNativeCodeVersion,
  getSystemVersion
} from "@/utils/js_bridge_info";
import { objectToQuery } from "./utils";

import { removeNoSenseKeys } from "@/utils/lodash";
import { isSubsOffer } from "@/utils/general_utils";
import PaymentUtil from "@/services/payment/paymentCache";

export const judgePaymentItemExist = (offer: any) => {
  // 获取配置中的paypal和stripe的有效性
  const paypal_enabled = store.getters[cg_user_types.GETTER_PAYPAL_ENABLE];
  const stripe_enabled = store.getters[cg_user_types.GETTER_CARD_ENABLE];

  // 判断是否是订阅
  const isSub = isSubsOffer(offer);

  // 获取支付展示权限的配置
  const { paypal, stripe, superPay } = store.getters[
    setting_types.GETTER_FEATURES_ITEM_BY_FUNCTION
  ](offer);
  // stripe不允许买订阅
  const canShowStripe: boolean =
    !isSub && stripe_enabled && judgeMethodCanUse(stripe);
  const canShowPayPal: boolean = paypal_enabled && judgeMethodCanUse(paypal);

  return {
    canShowStripe,
    canShowPayPal
  };
};

export const assembleWebPayUrl = async (
  offer: Offer,
  pay_way: PayWay,
  defaultResource: any
): Promise<string> => {
  const user_coin = store.getters[cg_user_types.GETTER_COINS];
  const master_id = store.getters[types.GETTER_MASTER_USER_ID];
  const resource = defaultResource
    ? defaultResource
    : getResourceFromOffer(offer);
  const actual_effect = calcPriceAndEffect(offer, pay_way)
    .with_vip_reward_effect;

  const params: any = {
    payby: pay_way,
    pf: getAppPlatform(),
    av: getNativeCodeVersion(),
    ss: getBundleId(),
    oi: offer.offer_id,
    pc: offer.effect,
    ps: getInfoFromOffer(offer, pay_way),
    uc: user_coin,
    ak: "getz",
    mt: 0,
    user_id: master_id,
    master_id,
    uj: { user_id: master_id, master_id },
    tj: resource,
    pk: offer.kind,
    sv: getSystemVersion(),
    dm: getMachine(),
    lg: getLang(),
    cui: getDeviceId(),
    iv: getIDFV(),
    ia: getIDFA()
  };
  actual_effect && (params.ae = actual_effect);
  const url: string = store.getters[setting_types.GETTER_WP_URL];
  console.log("params", params);
  return `${url}?${objectToQuery(removeNoSenseKeys(params))}`;
};

// 判断某种类型是否达到可用限制
export const judgeMethodCanUse = (type: FeatureItem | undefined): boolean => {
  try {
    if (!type) {
      return false;
    }
    const { is_enabled, delay } = type;
    const paymentParams: any = PaymentUtil.getPaymentParams();
    const {
      app_launch_time,
      iap_purchase_time,
      paypal_purchase_time,
      card_purchase_time,
      first_enter_timestamp
    } = paymentParams;
    // 总支付次数
    const purchase_sum =
      iap_purchase_time + paypal_purchase_time + card_purchase_time;
    if (!is_enabled) {
      return false;
    }
    const or_open_app = type.event.find((event: any) => {
      return event.eventName === "or_open_app";
    });
    const open_app = type.event.find((event: any) => {
      return event.eventName === "open_app";
    });
    const pay_by_iap = type.event.find((event: any) => {
      return event.eventName === "pay_by_iap";
    });
    const pay_by_cash = type.event.find((event: any) => {
      return event.eventName === "pay_by_cash";
    });
    const delay_action =
      new Date().getTime() - first_enter_timestamp > delay * 1000;
    const judge_or_open_app =
      !or_open_app || (or_open_app && app_launch_time >= or_open_app.count);
    const judge_open_app =
      !open_app || (open_app && app_launch_time >= open_app.count);
    const judge_pay_by_iap =
      !pay_by_iap || (pay_by_iap && iap_purchase_time >= pay_by_iap.count);
    const judge_pay_by_cash =
      !pay_by_cash || (pay_by_cash && purchase_sum >= pay_by_cash.count);
    return (
      is_enabled &&
      delay_action &&
      (judge_or_open_app ||
        (judge_open_app && judge_pay_by_iap && judge_pay_by_cash))
    );
  } catch (e) {
    return false;
  }
};
